// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2clq2","col":"styles_col__1hubR","actions":"styles_actions__2HgiY","conflict":"styles_conflict__cwgir"};